export default __webpack_public_path__ + "static/6-4cc9aa170edfe59df857693ce748d182.webp";